/**
 * Shared session-storage slot for the WorkPeriodOverview and approval-view
 * filters. Both forms use this name (and the same field union) so the selected
 * user and month are cached and stay in sync across the two views.
 */
export const WORK_PERIOD_FILTER_STORAGE = 'work-period-shared-filters'
